export const CustomHeader = ({ column }) => {
    const { headerName, title } = column;
  
    return (
      <div title={headerName} >
        <span>{headerName}</span>
      </div>
    );
  };